import { IObservable, Observable } from '@1js/oil-externals/rx';
import { take } from 'rxjs/operators';

import { WorkloadsService } from '../../shared/services/workloads.service';

export class ThirdPartyAppsFastSuggestionProvider {
    public static workloadsService: WorkloadsService;

    public createStream(searchText: string): IObservable<any /* TODO: Change to ISearchSuggestion when it's exported*/> {
        return Observable['fromPromise'](
            // getThirdPartyWorkloads() returns observable that replays last value so take(1) will pick it up immediately if it is already available;
            // otherwise, take(1) will wait for next value until it comes
            ThirdPartyAppsFastSuggestionProvider.workloadsService.getThirdPartyWorkloads().pipe(take(1)).toPromise().then(appData => {
                if (appData) {
                    return appData.map(app => ({
                        id: app.Id,
                        url: app.Url,
                        title: app.Text,
                        iconClass: !app.ThirdPartyIcon ?
                            app.IconUnicodeCodepointCssClass :
                            '',
                        iconUrl: app.ThirdPartyIcon,
                        type: 'app'
                    }));
                }
                return [];
            })
        ).select((suggestions: Array<any>) =>
                suggestions.filter(suggestion =>
                    !searchText || (suggestion.title && suggestion.title.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase().trim()) !== -1)))
            .selectMany(appSuggestions => Observable.fromArray(appSuggestions));
    }

    public getId(): string {
        return 'ThirdPartyAppsFastSuggestionProvider';
    }
}
